import angular from 'angular';
import URLS from 'Helpers/urls';

(function() {
    'use strict';

    angular.module('app').component('regularClassModal', {
        template: require('./regular-class-modal.html'),
        controller: RegularClassModalCtrl,
        controllerAs: 'vm',
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }
    });

    RegularClassModalCtrl.$inject = [
        '$scope',
        '$cookies',
        '$timeout',
        'QueryService'
    ];

    function RegularClassModalCtrl($scope, $cookies, $timeout, QueryService) {
        var vm = this;
        vm.content = null;

        vm.approve = approve;
        vm.cancel = cancel;
        vm.getClass = getClass;
        vm.confirm = confirm;

        vm.$onInit = function() {
            vm.content = angular.copy(vm.resolve.content);
            getSchedule();
        };

        vm.tomorrow = false;
        vm.start_hour = 6;
        vm.end_hour = 25;
        vm.hour_divisions = 4;
        vm.available_schedule = [];

        vm.minutes_increment = 60 / vm.hour_divisions;
        vm.clicked_dates = [];

        vm.days = [1, 2, 3, 4, 5];
        vm.hours = [];
        for (
            let i = vm.start_hour * vm.hour_divisions;
            i < vm.end_hour * vm.hour_divisions;
            i++
        ) {
            vm.hours.push(i);
        }

        vm.minutes = [];
        for (let i = 0; i < vm.hour_divisions; i++) {
            vm.minutes.push(vm.minutes_increment * i);
        }

        vm.set_tomorrow = function(val) {
            vm.tomorrow = val;
        };

        vm.getSchedule = getSchedule;
        function getSchedule() {
            vm.loading = true;
            var request = {
                method: 'GET',
                body: false,
                params: false,
                hasFile: false,
                route: URLS.base + `/schedule/1/available`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.available_schedule = response.data.data.items;
                    },
                    function(error) {
                        // logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }

        // hour: 0 - 24
        function approve(hour, day) {
            const available = vm.available_schedule.filter(h => {
                return h.hour === hour && h.day === day;
            })[0]
            ;

            if (
                vm.clicked_dates.length > 0 &&
                vm.clicked_dates[0].hour !== hour
            ) {
            } else if (available) {
                if (vm.clicked_dates.indexOf(available) >= 0) {
                    vm.clicked_dates.splice(
                        vm.clicked_dates.indexOf(available),
                        1
                    );
                } else {
                    vm.clicked_dates.push(available);
                }
            }
        }

        function getClass(hour, day) {
            let class_string = '';
            const c = vm.available_schedule.filter(x => {
                return x.hour == hour && x.day == day;
            })[0];

            const available = vm.clicked_dates.filter(h => {
                return h.hour == hour && h.day == day;
            });

            if (
                vm.clicked_dates.length > 0 &&
                vm.clicked_dates[0].hour !== hour
            ) {
                class_string += 'regular_class_disabled ';
            }

            if (vm.clicked_dates.indexOf(available[0]) >= 0) {
                return class_string + 'clicked_hour';
            } else {
                return (
                    class_string + (c ? 'available' : 'schedule-unavailable')
                );
            }
            /*
            return c
                ? 'clicked_hour'
                : available >= 0 ? 'available' : 'schedule-unavailable';
                */
        }

        function confirm() {
            vm.modalInstance.close(vm.clicked_dates);
        }

        function cancel() {
            vm.modalInstance.close();
        }

        vm.to_time = function(hour) {
            return (
                ('' + parseInt(hour / vm.hour_divisions)).padStart(2, 0) +
                ':' +
                ('' +
                    hour %
                        vm.hour_divisions *
                        (60 / vm.hour_divisions)).padStart(2, 0)
            );
        };

        vm.to_hour = function(hour) {
            return hour % 4 === 0
                ? `
                    ${'' + parseInt(hour / vm.hour_divisions)}:00
            `
                : '';
        };

        function _hour_to_hour(hour){
            return parseInt(hour / 4);
        }

        vm.date_opened = false;
        vm.open = function($event) {
            vm.date_opened = true;
        };
    }
})();



// WEBPACK FOOTER //
// ./src/app/shared/modals/regular-class-modal/regular-class-modal.component.js